<template>
  <v-menu
    bottom
    offset-y
  >
    <template
      v-slot:activator="{ on }"
    >
      <v-badge
        bordered
        color="error"
        :content="records.length"
        overlap
        :value="records.length > 0"
      >
        <!-- Mobile: plain blue bell in the mobile top bar -->
        <v-btn
          v-if="$vuetify.breakpoint.mdAndDown"
          class="plain"
          color="blue"
          plain
          small
          fab
          v-on="on"
        >
          <v-icon class="white--text">fa-bell fa-sm</v-icon>
        </v-btn>

        <!-- Desktop: rounded-square outlined button in the header bar -->
        <v-btn
          v-else
          class="ml-4 rounded-lg bell-btn"
          outlined
          height="38"
          width="38"
          min-width="38"
          v-on="on"
        >
          <v-icon small>fa-bell</v-icon>
        </v-btn>
      </v-badge>
    </template>
    <v-card
      style="width: 360px; max-width: 100%;"
    >
      <div class="d-flex pa-5 justify-space-between cdseo-grey-bg">
        <div class="font-weight-bold">Notifications</div>
        <v-btn
          v-if="records.length"
          class="body-2 text-decoration-none"
          text
          color="primary"
          @click.stop="clearAll"
          :disabled="loading"
          x-small
        >Clear All</v-btn>
      </div>
      <div
        v-if="!records.length"
        class="pa-5 text-center"
      >
        You have no alerts.
      </div>
      <div
        style="max-height: 400px; overflow-y: auto;"
      >
        <alert-menu-item
          v-for="record in records"
          :key="record.id"
          :record="record"
        />
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { Alert } from '@/models'
import AlertMenuItem from './AlertMenuItem.vue'

export default {
  components: {
    AlertMenuItem
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    records () {
      return Alert.query()
        .where(r => !!r.uncleared)
        .orderBy('id', 'desc')
        .all()
    }
  },
  methods: {
    async clearAll () {
      this.loading = true
      try {
        await this.$http({
          method: 'POST',
          url: '/api/alert/clear_all'
        })
        Alert.deleteAll()
      } finally {
        this.loading = false
      }
    }
  },
  created () {
    Alert.initPolling()
  }
}
</script>

<style scoped>
/* Subtle, theme-aware border for the desktop bell button */
.bell-btn {
  border-color: rgba(0, 0, 0, 0.12) !important;
}
.theme--dark .bell-btn {
  border-color: rgba(255, 255, 255, 0.18) !important;
}
</style>
